var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-checkList__row",class:[{ 'm-checkList__row--active': _vm.rowCheckbox }]},[_c('ui-checkbox-input',{staticClass:"text-primary text-sm",attrs:{"name":`row-${_vm.row.id}`,"label":_vm.row.label},model:{value:(_vm.rowCheckbox),callback:function ($$v) {_vm.rowCheckbox=$$v},expression:"rowCheckbox"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }